// src/pages/ContactPage.js
import React from 'react';
import { useLang } from '../i18n/LanguageContext';
import { EMAIL, MAP_EMBED, MAP_LINK, PHONE_DISPLAY, PHONE_TEL, WHATSAPP } from '../data/contact';
import ContactForm from '../components/Contact/ContactForm';
import { Breadcrumb, usePageTitle } from '../components/layout/PageBits';
import { IMG } from '../data/media';

// Split layout: where we are (map + office) on one side, ways to reach us and the form on the other.
function ContactPage() {
  const { t } = useLang();
  usePageTitle(t('navContact'));
  return (
    <div className="bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <Breadcrumb current={t('navContact')} />
        <h1 className="text-3xl sm:text-5xl font-extrabold tracking-tight">{t('cTitlePage')}</h1>
        <p className="mt-3 text-slate-600 max-w-2xl">{t('cSubPage')}</p>
        <div className="mt-10 grid lg:grid-cols-2 gap-8">
          <div className="space-y-4">
            <div className="rounded-3xl overflow-hidden border border-slate-200 h-72 sm:h-80 bg-slate-100">
              <iframe src={MAP_EMBED} title={t('mapTitle')} className="w-full h-full border-0" loading="lazy" referrerPolicy="no-referrer-when-downgrade" allowFullScreen />
            </div>
            <div className="grid sm:grid-cols-[1fr_1.3fr] gap-4">
              <img src={IMG.office} alt="" aria-hidden="true" loading="lazy" decoding="async" className="rounded-3xl w-full h-full min-h-[160px] object-cover" />
              <div className="rounded-3xl bg-cream p-5">
                <div className="font-bold">{t('vTitle')}</div>
                <p className="mt-1 text-sm text-slate-600">{t('addr')}</p>
                <p className="mt-2 text-sm text-slate-500">{t('hours')}</p>
                <a href={MAP_LINK} target="_blank" rel="noopener noreferrer" className="mt-3 inline-block text-sm font-semibold text-brand">{t('map')}</a>
              </div>
            </div>
          </div>
          <div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
              <a href={PHONE_TEL} className="rounded-2xl bg-ink text-white p-4"><div className="text-xl" aria-hidden="true">📞</div><div className="mt-1 text-xs text-white/60">{t('call')}</div><div className="font-bold text-sm">{PHONE_DISPLAY}</div></a>
              <a href={WHATSAPP} className="rounded-2xl bg-emerald-500 text-white p-4"><div className="text-xl" aria-hidden="true">💬</div><div className="mt-1 text-xs text-white/80">WhatsApp</div><div className="font-bold text-sm">{PHONE_DISPLAY}</div></a>
              <a href={`mailto:${EMAIL}`} className="rounded-2xl bg-sky text-ink p-4 min-w-0"><div className="text-xl" aria-hidden="true">✉️</div><div className="mt-1 text-xs text-slate-500">Email</div><div className="font-bold text-sm break-all">{EMAIL}</div></a>
            </div>
            <div className="mt-6 rounded-3xl border border-slate-200 shadow-sm p-6 sm:p-8">
              <h2 className="text-xl font-extrabold mb-1">{t('cFormTitle')}</h2>
              <p className="text-sm text-slate-500 mb-5">{t('cFormSub')}</p>
              <ContactForm />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactPage;
